// Screen `public-page` (plan §3.1, §9.8) — owner: library. A page published to the web.
import { createFileRoute } from '@tanstack/react-router';
import { PublicPage } from '../../../features/library/PublicPage';

export const Route = createFileRoute('/_public/p/$token')({
  component: function PublicPageRoute() {
    const { token } = Route.useParams();
    return <PublicPage token={token} />;
  },
});
